var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "libaray",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.123,19A1.131,1.131,0,0,1,0,17.864V6.165A1.13,1.13,0,0,1,1.123,5.029H20.878A1.128,1.128,0,0,1,22,6.165v11.7A1.129,1.129,0,0,1,20.878,19ZM2.534,3.613a.615.615,0,0,1,0-1.23H19.515a.615.615,0,0,1,0,1.23ZM4,1.231a.554.554,0,0,1-.55-.557V.557A.554.554,0,0,1,4,0H17.787a.555.555,0,0,1,.551.557V.674a.555.555,0,0,1-.551.557Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenre);
export default __webpack_public_path__ + "static/media/Genre.c7502b703e79e9d17e6337af8cb90947.svg";
export { ForwardRef as ReactComponent };